module.exports = __webpack_public_path__ + "img/logo-dark.b3d47ac3.png";